<ng-container *ngIf="sys === 'wt'">
  <img *ngIf="('logoFlat' | translate)" [attr.src]="baseUrl + sys + '/flat/'+ prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />

  <img
    *ngIf="product != 'raffles' && !('logoFlat' | translate)"
    [attr.src]="baseUrl + sys + '/high-quality/' + prodId +'.png'"
    class="lotto-logo"
    [attr.alt]="lottoName"
  />

  <img
    *ngIf="product === 'raffles' && !('logoFlat' | translate)"
    [attr.src]="baseUrl + sys + '/r_' + prodId +'.png'"
    width="90"
    class="lotto-logo"
    [attr.alt]="lottoName"
  />
</ng-container>

<ng-container *ngIf="sys === 'ltk'">
  <img
    *ngIf="product != 'raffles' && product != 'syndicates'"
    [attr.src]="baseUrl + sys + '/' + prodId +'.png'"
    width="70"
    class="lotto-logo"
    [attr.alt]="lottoName"
  />
  <ng-container *ngIf="('lang' | translate) === 'en'">
    <img *ngIf="product === 'syndicates'" [attr.src]="baseUrl + sys + '/en/syn_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
    <img *ngIf="product === 'raffles'" [attr.src]="baseUrl + sys + '/en/r_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
  </ng-container>
  <ng-container *ngIf="('lang' | translate) === 'es'">
    <img *ngIf="product === 'syndicates'" [attr.src]="baseUrl + sys + '/es/syn_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
    <img *ngIf="product === 'raffles'" [attr.src]="baseUrl + sys + '/es/r_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
  </ng-container>
  <ng-container *ngIf="('lang' | translate) === 'pl'">
    <img *ngIf="product === 'syndicates'" [attr.src]="baseUrl + sys + '/pl/syn_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
    <img *ngIf="product === 'raffles'" [attr.src]="baseUrl + sys + '/pl/r_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
  </ng-container>
  <ng-container *ngIf="('lang' | translate) === 'pt'">
    <img *ngIf="product === 'syndicates'" [attr.src]="baseUrl + sys + '/pt/syn_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
    <img *ngIf="product === 'raffles'" [attr.src]="baseUrl + sys + '/pt/r_' + prodId +'.png'" class="lotto-logo" [attr.alt]="lottoName" />
  </ng-container>
</ng-container>
